!function () {
    "use strict";
    class t extends HTMLElement {
        constructor() {
            super();
            this.section = this.closest("product-info");
            this.form = this.section.querySelector("[data-product-form]");
            this.formWrapper = theme.settings.productPageSticky && this.section.querySelector("[data-form-wrapper]") || this.form;
            this.triggerPoint = Infinity;
            this.handleProductAddError = this.handleProductAddError.bind(this);
            this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
            this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
        }
        connectedCallback() {
            this.setCartBarHeight();
            this.addEventListener("click", this.handleClick.bind(this));
            document.addEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
            document.addEventListener("theme:resize", this.boundSetCartBarHeight);
            document.addEventListener("theme:product:add-error", this.handleProductAddError);
        }
        handleClick(t) {
            const e = t.target.closest("[data-cart-bar-add-to-cart]");
            if (e) {
                t.preventDefault();
                e.classList.add("is-loading");
                e.setAttribute("disabled", "disabled");
                const mainBtn = this.form.querySelector("[data-add-to-cart]");
                if (mainBtn) {
                    this.form.requestSubmit(mainBtn);
                }
                return;
            }
            t.target.closest("[data-cart-bar-scroll]") && (t.preventDefault(), this.scrollToTop());
        }
        handleProductAddError() {
            this.querySelector("[data-cart-bar-add-to-cart]") && this.scrollToTop();
        }
        scrollToTop() {
            const t = this.section.querySelector("variant-selects"),
                e = (window.theme.isMobile() ? t || this.form : this.section).getBoundingClientRect().top;
            window.theme.scrollTo(window.theme.isMobile() ? e - 10 : e);
        }
        toggleCartBarOnScroll() {
            // Compare against the cached trigger point so scroll never reads layout.
            this.classList.toggle("is-visible", window.scrollY > this.triggerPoint);
        }
        updateTriggerPoint() {
            // READ-ONLY: recompute the scroll position where the bar should appear.
            // Stable during scroll, so we only refresh on connect and resize.
            this.triggerPoint = this.formWrapper ? this.formWrapper.offsetTop + this.formWrapper.offsetHeight : Infinity;
        }
        setCartBarHeight() {
            // Group reads, then defer the write to the next frame to avoid a
            // synchronous read-write reflow inside the resize handler.
            const t = this.offsetHeight;
            this.updateTriggerPoint();
            window.requestAnimationFrame(() => {
                document.documentElement.style.setProperty("--cart-bar-height", `${t}px`);
            });
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:add-error", this.handleProductAddError);
            document.removeEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
            document.removeEventListener("theme:resize", this.boundSetCartBarHeight);
        }
    }
    customElements.get("cart-bar") || customElements.define("cart-bar", t);
}();
